export default function isValidValue(value?: any) {
    return value !== null && value !== undefined && value !== "";
}
